import type { ContractBucketUri } from './bucket-api';

/** Types d'`Uri` du contrat (discriminant de `Uri` dans `merged.yaml`). */
export const BUCKET_TYPES = ['s3', 'managed', 'azure', 'gcp', 'generic'] as const;
export type BucketType = (typeof BUCKET_TYPES)[number];

export const bucketType = (uri: ContractBucketUri | undefined): BucketType | 'unknown' =>
  BUCKET_TYPES.find((type) => type === uri?.type) ?? 'unknown';

/**
 * Onglets du détail d'un bucket. L'onglet actif et le dossier courant vivent dans l'URL.
 * « Définition » (2026-10-23) : nom, description, étiquettes, point d'accès et région en JSON Patch.
 */
export const BUCKET_TABS = ['files', 'summary', 'definition'] as const;
export type BucketTab = (typeof BUCKET_TABS)[number];

export const isBucketTab = (value: unknown): value is BucketTab =>
  typeof value === 'string' && (BUCKET_TABS as readonly string[]).includes(value);

/** Au-delà, `listObjectsV2` sans jeton de continuation a coupé la liste (revue DM-06). */
export const BACKEND_LISTING_CAP = 1_000;
